<template>
  <a-layout id="Layout">
    <a-layout-sider v-model="collapsed" width="16vw" :trigger="null" collapsible>
      <div class="logo">
        <img src="@/assets/icons/logo.jpg" alt="logo">
      </div>
      <a-menu ref="test" theme="dark" mode="inline" :selected-keys="selectedKeys" :open-keys="keys" :default-open-keys="defaultOpenKey" @openChange="changeKeys" @click="handleClick">
        <template v-for="item in menu">
          <a-menu-item v-if="!item.hasChildren && item.roles.indexOf(role) !== -1" :key="item.key">
            <svg-icon :icon-class="item.icon" />
            <span>{{ item.name }}</span>
          </a-menu-item>
          <a-sub-menu v-if="item.hasChildren && item.roles.indexOf(role) !== -1" :key="item.key">
            <span slot="title"><svg-icon :icon-class="item.icon" /><span>{{ item.name }}</span></span>
            <template v-for="i in item.children">
              <a-menu-item v-if="i.roles.indexOf(role) !== -1" :key="i.key">
                <svg-icon :icon-class="i.icon" />
                <span>{{ i.name }}</span>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </template>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header>
        <div class="header_left">
          <svg-icon :icon-class="$route.meta.icon" />
          <span>{{ title }}</span>
        </div>
      </a-layout-header>
      <a-layout-content
        :style="{ padding: '0 25px', minHeight: '280px' }"
      >
        <router-view />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { removePageKey } from '@/utils/auth'

// {value: 1, name: "普通用户"}
// {value: 6, name: "物流账号"}
// {value: 4, name: "财务账户"}
// {value: 3, name: "客户经理"}
// {value: 2, name: "普通管理员"}
// {value: 5, name: "超级管理员"}
// 上面旧下面新 3=>2  2=>4
// {value: 1, name: "普通用户"}
// {value: 2, name: "客户经理"}
// {value: 3, name: "初评"}
// {value: 4, name: "普通管理员"}
// {value: 5, name: "超级管理员"}
// key为索引路径
const adminMenu = [{
  name: '概览',
  roles: [2, 3, 4, 5, 6],
  key: '0',
  icon: 'gailan',
  hasChildren: true,
  children: [{
    name: '参赛作品',
    roles: [2, 4, 5, 6],
    key: '0-0',
    icon: 'cansaizuopin',
    path: '/admin/products'
  },
  {
    name: '获奖作品',
    roles: [2, 4, 5, 6],
    key: '0-1',
    icon: 'cansaizuopin',
    path: '/admin/productAwards'
  },
  // {
  //   name: '对公转账',
  //   roles: [4, 5],
  //   key: '0-1',
  //   icon: 'publicTransfer',
  //   path: '/admin/publicTransfer'
  // },
  {
    name: '作品日志',
    roles: [4, 5],
    key: '0-2',
    icon: 'rizhi',
    path: '/admin/record'
  },
  {
    name: '欢迎',
    roles: [3],
    key: '0-3',
    icon: 'cansaizuopin',
    path: '/admin/welcome'
  }]
}, {
  name: '评审',
  roles: [3, 5],
  key: '1',
  icon: 'cansaizuopin',
  hasChildren: true,
  children: [{
    name: '初筛',
    roles: [5],
    key: '1-0',
    icon: 'cansaizuopin',
    path: '/admin/initialScreening'
  },
  {
    name: '初审',
    roles: [5],
    key: '1-1',
    icon: 'cansaizuopin',
    path: '/admin/judge'
  },
  {
    name: '初评评分表',
    roles: [5],
    key: '1-2',
    icon: 'cansaizuopin',
    path: '/admin/judgeScore'
  },
  {
    name: '复评',
    roles: [5],
    key: '1-3',
    icon: 'cansaizuopin',
    path: '/admin/reReview'
  },
  {
    name: '复评评分表',
    roles: [],
    key: '1-4',
    icon: 'cansaizuopin',
    path: '/admin/judgeReScore'
  },
  {
    name: '终评作品',
    roles: [3, 5],
    key: '1-5',
    icon: 'cansaizuopin',
    path: '/admin/finalReview'
  }
  ]
}, {
  name: '设置',
  roles: [2, 3, 4, 5, 6],
  key: '2',
  icon: 'shezhi',
  hasChildren: true,
  children: [{
    name: '奖项',
    roles: [5],
    key: '2-0',
    icon: 'mamaniandujiangxiang',
    path: '/admin/rewards'
  }, {
    name: '奖项日志',
    roles: [5],
    key: '2-1',
    icon: 'rizhi',
    path: '/admin/rewardsLog'
  },
  // {
  //   name: '获奖者服务',
  //   roles: [5],
  //   key: '2-2',
  //   icon: 'rizhi',
  //   path: '/admin/winnerService'
  // },
  {
    name: '用户',
    roles: [5],
    key: '2-2',
    icon: 'yonghu',
    path: '/admin/users'
  }, {
    name: '用户日志',
    roles: [5],
    key: '2-3',
    icon: 'rizhi',
    path: '/admin/userLog'
  },
  // {
  //   name: '相关文档',
  //   roles: [5],
  //   key: '2-4',
  //   icon: 'xinxi',
  //   path: '/user/document'
  // },
  {
    name: '通知群发',
    roles: [],
    key: '2-4',
    icon: 'qunfaxinxi',
    path: '/admin/message'
  },
  {
    name: '更改密码',
    roles: [2, 3, 4, 5, 6],
    key: '2-5',
    icon: 'mima',
    path: '/admin/password'
  },
  {
    name: '退出登陆',
    roles: [2, 3, 4, 5, 6],
    key: '2-6',
    icon: 'tuichudenglu',
    path: ''
  }]
}]

const userMenu = [{
  name: '作品信息',
  roles: [1],
  key: '0',
  icon: 'xinxi',
  hasChildren: true,
  children: [{
    name: '作品报名',
    roles: [1],
    key: '0-0',
    icon: 'baoming',
    path: '/user/registration'
  }, {
    name: '我的作品',
    roles: [1],
    key: '0-1',
    icon: 'chanpin2',
    path: '/user/myProduct'
  }
  // {
  //   name: '相关文档',
  //   roles: [1],
  //   key: '0-2',
  //   icon: 'xinxi',
  //   path: '/user/document'
  // }
  ]
}, {
  name: '我的账户',
  roles: [1],
  key: '1',
  icon: 'yonghu',
  hasChildren: true,
  children: [{
    name: '我的地址',
    roles: [1],
    key: '1-0',
    icon: 'dizhi',
    path: '/user/address'
  }, {
    name: '更改密码',
    roles: [1],
    key: '1-1',
    icon: 'mima',
    path: '/user/password'
  }, {
    name: '退出登陆',
    roles: [1],
    key: '1-2',
    icon: 'tuichudenglu',
    path: ''
  }]
}]

export default {
  data() {
    return {
      collapsed: false,
      menu: [],
      title: '',
      selectedKeys: ['0-0'],
      defaultOpenKey: ['0-0', '0'],
      role: 1,
      keys: ['0-0', '0']
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    }
  },
  watch: {
    locale(e) {
      if (this.$store.getters.user.role === 1) {
        this.menu[0].name = this.$t('view-components-components/productm')
        this.menu[0].children[0].name = this.$t('view-components-components/Sign up')
        this.menu[0].children[1].name = this.$t('user-productInfo-myProduct/myProduct')
        // this.menu[0].children[2].name = this.$t('view-components-components/relevantDocuments')
        this.menu[1].name = this.$t('view-components-components/mine')
        this.menu[1].children[0].name = this.$t('user-account-address/address')
        this.menu[1].children[1].name = this.$t('user-account-password/change')
        this.menu[1].children[2].name = this.$t('view-components-components/out')
        this.title = this.menu[0].name
      } else {
        this.menu[0].name = this.$t('view-components-components/overview')
        this.menu[0].children[0].name = this.$t('admin-profile-product/product')
        // this.menu[0].children[1].name = this.$t('view-components-components/payType4')
        this.menu[0].children[2].name = this.$t('admin-profile-log/log')
        this.menu[0].children[3].name = this.$t('admin-judge/welcome')
        this.menu[1].name = this.$t('admin-judge/judge')
        this.menu[1].children[0].name = this.$t('admin-judge/initialScreening')
        this.menu[1].children[1].name = this.$t('admin-judge/initialReview')
        this.menu[1].children[2].name = this.$t('admin-judge/judgeScore')
        this.menu[1].children[3].name = this.$t('admin-judge/reReview')
        // this.menu[1].children[3].name = this.$t('admin-judge/review')
        // this.menu[1].children[4].name = this.$t('admin-judge/judgeReScore')
        // this.menu[1].children[5].name = this.$t('admin-judge/judgeReResult')
        this.menu[2].name = this.$t('view-components-components/Set up')
        this.menu[2].children[0].name = this.$t('admin-profile-product/awards')
        this.menu[2].children[1].name = this.$t('setting-awardsLog/awardsLog')
        // this.menu[2].children[2].name = this.$t('view-components-components/winnerService')
        this.menu[2].children[2].name = this.$t('setting-user/users')
        this.menu[2].children[3].name = this.$t('view-components-components/Log')
        // this.menu[2].children[4].name = this.$t('view-components-components/relevantDocuments')
        this.menu[2].children[4].name = this.$t('setting-user-letters/letters')
        this.menu[2].children[5].name = this.$t('user-account-password/change')
        this.menu[2].children[6].name = this.$t('view-components-components/out')
        this.title = this.menu[0].name
      }
    },
    $route(e) {
      this.setKey(e.path)
    }
  },
  created() {
    this.menu = this.$store.getters.user.role === 1 ? userMenu : adminMenu
    this.role = this.$store.getters.user.role
    if (this.$store.getters.user.role === 1) {
      this.menu[0].name = this.$t('view-components-components/productm')
      this.menu[0].children[0].name = this.$t('view-components-components/Sign up')
      this.menu[0].children[1].name = this.$t('user-productInfo-myProduct/myProduct')
      // this.menu[0].children[2].name = this.$t('view-components-components/relevantDocuments')
      this.menu[1].name = this.$t('view-components-components/mine')
      this.menu[1].children[0].name = this.$t('user-account-address/address')
      this.menu[1].children[1].name = this.$t('user-account-password/change')
      this.menu[1].children[2].name = this.$t('view-components-components/out')
    } else {
      this.menu[0].name = this.$t('view-components-components/overview')
      this.menu[0].children[0].name = this.$t('admin-profile-product/product')
      // this.menu[0].children[1].name = this.$t('view-components-components/payType4')
      this.menu[0].children[2].name = this.$t('admin-profile-log/log')
      this.menu[0].children[3].name = this.$t('admin-judge/welcome')
      this.menu[1].name = this.$t('admin-judge/judge')
      this.menu[1].children[0].name = this.$t('admin-judge/initialScreening')
      this.menu[1].children[1].name = this.$t('admin-judge/initialReview')
      this.menu[1].children[2].name = this.$t('admin-judge/judgeScore')
      this.menu[1].children[3].name = this.$t('admin-judge/reReview')
      this.menu[1].children[4].name = '终评作品'
      // this.menu[1].children[3].name = this.$t('admin-judge/review')
      // this.menu[1].children[4].name = this.$t('admin-judge/judgeReScore')
      // this.menu[1].children[5].name = this.$t('admin-judge/judgeReResult')
      this.menu[2].name = this.$t('view-components-components/Set up')
      this.menu[2].children[0].name = this.$t('admin-profile-product/awards')
      this.menu[2].children[1].name = this.$t('setting-awardsLog/awardsLog')
      // this.menu[2].children[2].name = this.$t('view-components-components/winnerService')
      this.menu[2].children[2].name = this.$t('setting-user/users')
      this.menu[2].children[3].name = this.$t('view-components-components/Log')
      // this.menu[2].children[4].name = this.$t('view-components-components/relevantDocuments')
      this.menu[2].children[4].name = this.$t('setting-user-letters/letters')
      this.menu[2].children[5].name = this.$t('user-account-password/change')
      this.menu[2].children[6].name = this.$t('view-components-components/out')
    }
    this.title = this.menu[0].name
    const path = this.$route.path
    this.setKey(path)
  },
  methods: {
    changeKeys(keys) {
      this.keys = keys.length > 0 ? [keys[keys.length - 1]] : keys
    },
    setKey(path) {
      // 初评部分特殊处理路由
      switch (path) {
        case '/admin/initialScreeningList':
        case '/admin/initialScreeningDetail': {
          this.selectedKeys = ['1-0']
          this.defaultOpenKey = ['1-0', '1']
          this.keys = ['1-0', '1']
          this.title = this.menu[1].children[0].name
          return
        }
        case '/admin/judgeList':
        case '/admin/judgeDetail': {
          this.selectedKeys = ['1-1']
          this.defaultOpenKey = ['1-1', '1']
          this.keys = ['1-1', '1']
          this.title = this.menu[1].children[1].name
          return
        }
        case '/admin/judgeScoreDetail': {
          this.selectedKeys = ['1-2']
          this.defaultOpenKey = ['1-2', '1']
          this.keys = ['1-2', '1']
          this.title = this.menu[1].children[2].name
          return
        }
        case '/admin/reReviewList':
        case '/admin/reReviewDetail': {
          this.selectedKeys = ['1-3']
          this.defaultOpenKey = ['1-3', '1']
          this.keys = ['1-3', '1']
          this.title = this.menu[1].children[3].name
          return
        }
        case '/admin/finalReview':
        case '/admin/finalReviewList':
        case '/admin/finalReviewDetail': {
          this.selectedKeys = ['1-5']
          this.defaultOpenKey = ['1-5', '1']
          this.keys = ['1-5', '1']
          this.title = this.menu[1].children[4].name
          return
        }
        case '/admin/judgeReList':
        case '/admin/judgeReDetail': {
          this.selectedKeys = ['1-6']
          this.defaultOpenKey = ['1-6', '1']
          this.keys = ['1-6', '1']
          this.title = this.menu[1].children[6].name
          return
        }
        case '/admin/judgeReScoreDetail': {
          this.selectedKeys = ['1-4']
          this.defaultOpenKey = ['1-4', '1']
          this.keys = ['1-4', '1']
          this.title = this.menu[1].children[4].name
          return
        }
        default: break
      }
      // 默认两层子菜单
      for (const i in this.menu) {
        for (const j in this.menu[i].children) {
          if (this.menu[i].children[j].path === path) {
            this.selectedKeys = [this.menu[i].children[j].key]
            this.defaultOpenKey = [this.menu[i].children[j].key, this.menu[i].key]
            this.keys = [this.menu[i].children[j].key, this.menu[i].key]
            this.title = this.menu[i].children[j].name
            return
          }
        }
      }
    },
    handleClick(e) {
      if (this.$route.query.judgeConfirmTip) {
        const that = this
        this.$confirm({
          content: `您还未确认最终初评结果，请及时进行审核确认并点击页面下方的提交按钮。`,
          okText: '立刻确认',
          cancelText: '我再想想',
          onOk() {
          },
          onCancel() {
            that.go(e)
          }
        })
      } else {
        this.go(e)
      }
    },
    go(e) {
      // 清除所有pageKey
      removePageKey('editProductId')
      removePageKey('productStep')
      removePageKey('readonly')
      removePageKey('productConfirm')
      removePageKey('editLogisticsId')
      removePageKey('editInvoiceId')
      removePageKey('judgeScore')
      removePageKey('judgeIndex')
      removePageKey('judgeResult')
      const indexs = e.key.split('-')
      const item = this.menu[indexs[0]].children[indexs[1]]
      if (!item) return
      this.title = item.name
      if (item.name === this.$t('view-components-components/out')) {
        this.$store.dispatch('user/logout').then(res => {
          this.$router.push({ path: '/login' })
        }).catch(res => {
          console.error(res)
        })
      } else {
        if (item.path === this.$route.path) {
          if (window && window.location) {
            window.location.reload()
          } else {
            this.$router.go(0)
          }
        } else {
          this.$router.push({ path: item.path })
        }
      }
    }
  }
}
</script>
<style>
  #Layout {
    height: 100vh;
    background: #f8f8f8;
  }

  #Layout .ant-layout-sider {
    background: #ededed;
    z-index: 999;
    min-width: 192px !important;
  }

  #Layout .ant-menu {
    padding-left: 15px;
    background: #ededed;
    color: #333333;
  }

  #Layout .logo {
    margin: 51px auto 54px;
    text-align: center;
  }

  .logo img{
    width: 80%;
    /* height: 20vh; */
    /* width: 20vh; */
  }

  #Layout .ant-menu-item,
  #Layout .ant-menu-submenu-title {
    color: #333333;
    font-size: 14.65px;
    margin: 0;
    padding-left:10px !important;
  }

  #Layout .ant-menu-item:hover {
    background: #c2c2c2;
  }

  /* #Layout .ant-menu-item-selected:hover {
    background: #ed1c24
  } */

  #Layout .ant-menu-item svg,
  #Layout .ant-menu-submenu-title svg {
    margin-right: 14px;
  }

  #Layout .ant-menu-item svg + span {
    opacity: 1;
    transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  #Layout .ant-menu-item-selected svg,
  #Layout .ant-menu-item-selected svg + span {
    color: #fff;
  }

  #Layout .ant-menu-sub {
    background: #e0e0e0;
    box-shadow: none;
  }

  #Layout .ant-menu-submenu-arrow::before,
  #Layout .ant-menu-submenu-arrow::after {
    background: #333333;
  }

  #Layout .ant-layout-header {
    height: 93px;
    line-height: 93px;
    padding: 0 25px;
    background: #f8f8f8;
  }

  #Layout .ant-layout-content {
    position: relative;
  }

  .header_left {
    float: left;
    font-size: 20px;
  }

  .header_left span {
    margin-left: 12px;
  }

  .header_right {
    float: right;
  }

  #Layout .ant-layout {
    background: #f8f8f8;
    min-width: 1008px;
  }

  /* 表格统一风格 */
  #Layout .ant-table-thead > tr > th {
    background: #eeeeee;
  }

  #Layout .ant-table-tbody > tr {
    background: #ffffff;
  }

   #Layout .ant-table-tbody td {
     position: relative;
   }

  .viewRule {
    color: #ed1c24;
    cursor: pointer;
    text-decoration: underline;
  }

  /* 子菜单右移 */
  .ant-menu .ant-menu-item svg,
  .ant-menu .ant-menu-item span {
    transform: translateX(14px);
  }
</style>
